import { PopoverOrigin } from '@lyearn/ui';

export const ANCHOR_ORIGIN: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'left',
};

export const TRANSFORM_ORIGIN: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'left',
};

export const CLASSES = {
  paper: 'rounded-8 mt-8 shadow-02 border border-divider pt-16 max-w-320',
};
